import { render, staticRenderFns } from "./MoleculeEditionAssetInvitationsModalCreate.vue?vue&type=template&id=1851ee80&"
import script from "./MoleculeEditionAssetInvitationsModalCreate.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetInvitationsModalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports